const baseJobs = [
  {
    title: "Technical Support Engineer",
    type: "Full time",
    department: "Engineering",
    location: "Erbil",
    posted: "Posted 12 days ago",
    deadline: "24 Jan 2026",
  },
  {
    title: "Installation Supervisor",
    type: "Full time",
    department: "Engineering",
    location: "Erbil",
    posted: "Posted 11 days ago",
    deadline: "26 Jan 2026",
  },
  {
    title: "Academy Trainer - Gypsum Systems",
    type: "Full time",
    department: "Engineering",
    location: "Erbil",
    posted: "Posted 10 days ago",
    deadline: "28 Jan 2026",
  },
  {
    title: "Logistics & Delivery Coordinator",
    type: "Full time",
    department: "Operations",
    location: "Erbil",
    posted: "Posted 9 days ago",
    deadline: "30 Jan 2026",
  },
  {
    title: "Technical Sales Engineer",
    type: "Full time",
    department: "Sales",
    location: "Erbil",
    posted: "Posted 8 days ago",
    deadline: "01 Feb 2026",
  },
];

export const careersJobs = [...baseJobs, ...baseJobs, ...baseJobs].map(
  (job, index) => ({
    ...job,
    id: `job-${index + 1}`,
    order: index + 1,
    description:
      "We're looking for a Technical Support Engineer to expertly assist our clients. You'll tackle technical challenges, guide product usage, and ensure customer happiness. Strong problem-solving and communication skills are key. Knowledge of gypsum manufacturing and construction solutions is a plus. You'll collaborate with cross-functional teams to resolve complex issues and contribute to our knowledge base. If you're passionate about technology and customer service, join us in building the future of construction!",
    requirements: [
      "Has excellent problem-solving skills",
      "Is a strong communicator",
      "Is passionate about technology and customer service",
      "Has knowledge of gypsum manufacturing and construction solutions (a plus)",
    ],
    howToApply:
      "To apply, please click on the Apply now button and be sure to upload your CV/resume and tell us why you want to join IRQGYP. We look forward to hearing from you!",
  })
);

